/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_What_TitleInputs */

const en_fc_home_what_title = /** @type {(inputs: Fc_Home_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the FilmCraft video editor?`)
};

/**
* | output |
* | --- |
* | "What is the FilmCraft video editor?" |
*
* @param {Fc_Home_What_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_what_title = /** @type {((inputs?: Fc_Home_What_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_What_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_what_title(inputs)
});
export { fc_home_what_title as "fc.home.what.title" }